import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const SelectionIcon = ({ isSelected, multiple }) => {
  const iconName = multiple
    ? isSelected
      ? 'check-square'
      : 'square'
    : isSelected
    ? 'dot-circle'
    : 'circle';

  return <FontAwesomeIcon icon={iconName} fixedWidth />;
};

SelectionIcon.propTypes = {
  isSelected: PropTypes.bool,
  multiple: PropTypes.bool,
};

export default SelectionIcon;
